import { ApiClient } from '@webapp/core/services/ApiClient'
import { ShippingTermRepository } from './ShippingTermRepository'

export const shippingTermRepository = new ShippingTermRepository({
  httpClient: ApiClient,
})

export * from './ShippingTermRepository'
